import { FC } from "react";
import Home from "./Home";
import TotalUsersWidget from "./TotalUsersWidget";
import { HomeSection } from "./HomeSection";
import TotalActiveUsersWidget from "./TotalActiveUsersWidget";
import TotalLocationsWidget from "./TotalLocationsWidget";
import ActiveManagersWidget from "./ActiveManagersWidget";
import AssignmentsCompletionWidget from "./AssignmentsCompletionWidget";
import RecentAssignmentsWidget from "./RecentAssignmentsWidget";
import ActiveLanguagesWidget from "./ActiveLanguagesWidget";
import AvgTrainingFeedbackWidget from "./AvgTrainingFeedbackWidget";
import SHPProgressWidget from "./SHPProgressWidget";
import LocationAssignmentLeaderboardWidget from "./LocationAssignmentLeaderboardWidget";
import RecentFeedbackWidget from "./RecentFeedbackWidget";
import AskOpusBanner from "./AskOpusBanner";
import MyTrainingCarousel from "./MyTrainingCarousel";
import HomeQuickActions from "./HomeQuickActions";

const AdminHome: FC = () => {
  return (
    <Home>
      <div className="flex flex-col gap-4">
        <AskOpusBanner />

        <HomeQuickActions />

        <MyTrainingCarousel />

        <HomeSection title="Overview">
          <div className="grid grid-cols-2 gap-4">
            <TotalLocationsWidget />
            <TotalUsersWidget />
          </div>
        </HomeSection>
        <HomeSection title="Usage">
          <div className="grid grid-cols-2 gap-4">
            <TotalActiveUsersWidget />
            <ActiveManagersWidget />
          </div>
        </HomeSection>
        <HomeSection title="Assignments">
          <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
            <AssignmentsCompletionWidget />
            <LocationAssignmentLeaderboardWidget />
            <AvgTrainingFeedbackWidget />
            <RecentFeedbackWidget />
            <SHPProgressWidget />
            <RecentAssignmentsWidget />
            <ActiveLanguagesWidget />
          </div>
        </HomeSection>
      </div>
    </Home>
  );
};

export default AdminHome;
